const exchangeType = {
  EXCHANGE_RATES_TABLE_STATE_SET: 'EXCHANGE_RATES/TABLE_STATE_SET',
};
export default exchangeType;
